<script lang="ts" module>
  import type { SystemStyleObject } from '@agapi/ui/panda/types';
  import type { Collection } from '@agapi/mlc-core';
  import type { ActionComponentProps } from '@agapi/ui/utils';

  export interface StoryRowProps extends ActionComponentProps {
    collections: Collection[];
    ariaLabel: string;
    css?: SystemStyleObject;
}
</script>

<script lang="ts">
  import { Carousel, CarouselSlide } from '@agapi/ui/carousel';
  import { css } from '@agapi/ui/panda/css';
  import StoryItem from '../story-item/story-item.svelte';
  import { useActions } from '@agapi/ui/utils';

  const { use, collections, ariaLabel, css: cssProp = {} }: StoryRowProps = $props();

  const storyRowStyles = css.raw({
    pt: '4',
    pb: '0',
    '&::-webkit-scrollbar': { display: 'none' },
  });
</script>

<div
  role="region"
  aria-roledescription="carousel"
  aria-label={ariaLabel}
  class={css(storyRowStyles, cssProp)}
  use:useActions={use ?? []}
>
  <Carousel
    options={{ align: 'center', slidesToScroll: 4 }}
    css={{ gap: '3' }}
    fadeEdges
    centerOnOverflow
    hideIndicators
  >
    {#each collections as collection}
      <CarouselSlide>
        <StoryItem {...collection} />
      </CarouselSlide>
    {/each}
  </Carousel>
</div>
